import { Component, effect, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ReflectionFacade } from '@app/store/reflection';
import { UnavailableComponent } from '@shared/components';
import { DeleteButtonComponent } from './delete-button/delete-button.component';

@Component({
    selector: 'app-reflection-view-modal',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    imports: [TranslateModule, ButtonModule, DeleteButtonComponent, UnavailableComponent],
})
export class ViewComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly reflectionFacade = inject(ReflectionFacade);

    private readonly id = this.route.parent?.snapshot.params['id'];
    readonly reflection = this.reflectionFacade.reflection(this.id);
    readonly loading = this.reflectionFacade.loading(this.id);
    readonly error = this.reflectionFacade.error(this.id);
    readonly saving = this.reflectionFacade.saving;

    constructor() {
        if (this.id) {
            this.reflectionFacade.getReflection(this.id);
        }

        effect(() => {
            if (this.reflectionFacade.saved()) {
                this.close({ replaceUrl: !this.reflection() });
            }
        });
    }

    ngOnDestroy(): void {
        this.reflectionFacade.clear();
    }

    onEdit(): void {
        const reflection = this.reflection();
        if (reflection) {
            this.router.navigate([{ outlets: { modal: ['reflections', 'edit', reflection.id] } }]);
        }
    }

    close({ replaceUrl } = { replaceUrl: false }): void {
        this.router.navigate([{ outlets: { modal: null } }], { replaceUrl });
    }
}
